module.exports = __webpack_public_path__ + "b88eedbebd8a9599a0709c5bc8aacaf6.svg";